import { EScheduleType } from 'constants/enums';

export const DEFAULT_OFFER_DESIGN_EXTERNAL_ID = 'Default_RollingOffer';

export const SCHEDULE_TAB_TRIGGERS = [
    { value: EScheduleType.PERMANENT, label: 'Permanent' },
    { value: EScheduleType.SCHEDULED, label: 'Schedule' }
];

